import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_workers_who_handle_n_n_dimethylformamide_dmf'

export const dataPointDefinition = {
  retracedId: 'are_workers_who_handle_n_n_dimethylformamide_dmf',
  name: 'Are workers who handle N,N-Dimethylformamide (DMF) provided with required Personal Protection Equipment (PPE)?',
  description:
    'Required Personal Protection Equipment (PPE) for handling is A1 respirator or similar (gas and vapor filter), protective eyewear (full frame goggles) and protective gloves (in case of direct handling of the substance).',
  meta: {
    slcpMeta: {
      key: 'hs-wor-28',
      number: 'HS-WOR-11',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-che-16x',
      machineShowHide: '[2],hs-che-16x',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no',
      name: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-28', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31720,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
